export enum SignersColors {
  'orange',
  'lime',
  'blue',
  'indigo',
  'violet',
  'pink',
  'teal',
  'grey',
}
